export default __webpack_public_path__ + "static/media/move.f21d084d.png";